import CalendarHours, { CalendarHoursProps } from "./CalendarHours";
import { withLabel } from "composants/withLabel";

export const CalendarHoursAndLabel = withLabel<CalendarHoursProps>()(CalendarHours);

export default CalendarHoursAndLabel;
